import { render, staticRenderFns } from "./ReviewPreview.vue?vue&type=template&id=cae8a024"
import script from "./ReviewPreview.vue?vue&type=script&lang=js"
export * from "./ReviewPreview.vue?vue&type=script&lang=js"
import style0 from "./ReviewPreview.vue?vue&type=style&index=0&id=cae8a024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports